import React from 'react';
const WhoWeHelpV2 = ({ copy }) => {
  if (!copy) return null;
  return (
    <section className="iv2-who" data-testid="iv2-who">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline">{copy.headline}</h2>
        <ul className="iv2-who-list">
          {copy.items.map((it) => (
            <li key={it.id} className="iv2-who-item" data-testid={`iv2-who-item-${it.id}`}>
              <span className="iv2-who-item-label">{it.label}</span>
              <p className="iv2-who-item-body">{it.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
export default WhoWeHelpV2;
